import React from 'react';
import { ONBOARDING_TYPE } from '../../utils/Constant';
import OnboardingPage from './OnboardingPage';
import { REGISTRATION_APPROVAL_HEADER } from './OnboardingPageHelper';

const RegistrationApprovalPage: React.FunctionComponent = () => {
  return (
    <OnboardingPage
      onboardingType={ONBOARDING_TYPE.REGISTRATION_APPROVAL}
      columnsHeder={REGISTRATION_APPROVAL_HEADER}
      title="Registration Approval"
    />
  );
};
export default RegistrationApprovalPage;
